import { render, staticRenderFns } from "./FilterSummaryItem.vue?vue&type=template&id=3d468f92&"
import script from "./FilterSummaryItem.vue?vue&type=script&lang=js&"
export * from "./FilterSummaryItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports